import React, { useEffect, useState } from "react";
import api from "../../lib/api";
import { Shield, CheckCircle2 } from "lucide-react";

export default function AdminAuthenticity() {
  const [certs, setCerts] = useState([]);

  useEffect(() => {
    api.get("/admin/certificates").then((r) => setCerts(r.data || []));
  }, []);

  return (
    <div className="p-8 md:p-12" data-testid="admin-auth">
      <header className="mb-8">
        <p className="text-[11px] tracking-luxury uppercase text-poche-gold">Atelier · Authenticity</p>
        <h1 className="font-serif text-5xl mt-2">QR Certificate Manager</h1>
      </header>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
        {certs.map((c) => (
          <div key={c.certificate_id} className="bg-poche-ink border border-poche-gold/20 p-5">
            <div className="flex items-start justify-between">
              <Shield size={20} className="text-poche-gold" strokeWidth={1.4} />
              <span className={`text-[10px] tracking-luxury uppercase px-2 py-1 ${c.warranty_status === "registered" ? "border border-poche-gold/50 text-poche-gold" : "border border-white/15 text-white/55"}`}>
                {c.warranty_status}
              </span>
            </div>
            <div className="font-serif text-xl mt-3 text-poche-gold">{c.certificate_id}</div>
            <div className="text-[10px] tracking-luxury uppercase text-white/45 mt-1">Serial · {c.serial_number}</div>
            {c.owner_name && (
              <div className="border-t border-white/10 mt-4 pt-3 text-sm">
                <div className="text-[10px] tracking-luxury uppercase text-white/45">Registered To</div>
                <div>{c.owner_name}</div>
                <div className="text-white/55 text-xs">{c.owner_email}</div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
